import { useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import footerTeam from "../../../assets/team/footer-team.png";
import footerTeam_es from "../../../assets/team/footer-team_es.png";
import { UserProvider } from "../../../router/AppProvider";

const TeamFooter = () => {
  const { language } = useContext(UserProvider);

  return (
    <Container>
      <Row>
        <Col md={12} className="text-center mx-auto">
          <div className="mx-auto">
            {language === "en" ? (
              <img className="img-fluid" src={footerTeam} alt="WOP" />
            ) : (
              <img className="img-fluid" src={footerTeam_es} alt="WOP" />
            )}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default TeamFooter;
